import React from 'react'
import {
  faCircle,
  faEye,
  faFileExport,
} from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCprimaryColor,
  $green_warm,
  $light_blue_warm,
  $light_green_warm,
  $red_warm,
  $yellow_warm,
  DcBreadcrumbs,
  DcFlexBox,
  PixelButton,
  PixelCurrency,
  PixelIcon,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  Section,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'
import {
  getCourierBalances,
  getGeneralCourierList,
} from 'utils/api-routes.util'

const addAlpha = (color, opacity) => {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
  return color + _opacity.toString(16).toUpperCase()
}

const columns = [
  {
    dataKey: 'courier_name',
    name: 'Courier Name',
    sortable: true,
    selector: (row) => row.courier_name || '--',
  },
  {
    dataKey: 'total_orders_delivered',
    name: 'Delivered',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total_orders_delivered} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($light_blue_warm, '0.8'),
          color: 'white',
        },
        classNames: 'blue-warm-bg-15 blue-warm text-center',
      },
    ],
  },
  {
    dataKey: 'total_orders_returned',
    name: 'Returned',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total_orders_returned} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($light_blue_warm, '0.8'),
          color: 'white',
        },
        classNames: 'blue-warm-bg-15 blue-warm text-center',
      },
    ],
  },
  {
    dataKey: 'total_orders_inprocess',
    name: 'In-Process',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total_orders_inprocess} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($light_green_warm, '0.8'),
          color: 'white',
        },
        classNames: 'green-warm-bg-15 green-warm text-center',
      },
    ],
  },
  {
    dataKey: 'total_amount_delivered',
    name: 'Delivered',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total_amount_delivered} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($light_green_warm, '0.8'),
          color: 'white',
        },
        classNames: 'green-warm-bg-15 green-warm text-center',
      },
    ],
  },
  {
    dataKey: 'total_amount_inprocess',
    name: ' In-Process',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total_amount_inprocess} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($light_green_warm, '0.8'),
          color: 'white',
        },
        classNames: 'green-warm-bg-15 green-warm text-center',
      },
    ],
  },
  {
    dataKey: 'total_receivable',
    name: 'Total',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total_receivable} currency={'USD'} /> || '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($light_green_warm, '0.8'),
          color: 'white',
        },
        classNames: 'green-warm-bg-15 green-warm text-center',
      },
    ],
  },
  {
    dataKey: 'total_payment_received',
    name: 'Received',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.total_payment_received} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($green_warm, '0.8'),
          color: 'white',
        },
        classNames: 'green-warm green-bg text-center',
      },
    ],
  },
  {
    dataKey: 'balance',
    name: 'Balance',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.balance} currency={'USD'} /> || '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($green_warm, '0.8'),
          color: 'white',
        },
        classNames: 'green-warm green-bg text-center',
      },
    ],
  },
  {
    dataKey: 'shipping_cost_delivered',
    name: 'Delivered',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.shipping_cost_delivered} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($red_warm, '0.8'),
          color: 'white',
        },
        classNames: 'red-warm-bg-15 red-warm text-center',
      },
    ],
  },
  {
    dataKey: 'shipping_cost_returned',
    name: 'Returned',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.shipping_cost_returned} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($red_warm, '0.8'),
          color: 'white',
        },
        classNames: 'red-warm-bg-15 red-warm text-center',
      },
    ],
  },
  {
    dataKey: 'shipping_cost_total',
    name: 'Total',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.shipping_cost_total} currency={'USD'} /> ||
      '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($red_warm, '0.8'),
          color: 'white',
        },
        classNames: 'red-warm-bg-15 red-warm text-center',
      },
    ],
  },
  {
    dataKey: 'shipping_cost_avg_delivered',
    name: ' Delivered',
    sortable: true,
    selector: (row) =>
      (
        <PixelCurrency
          value={row.shipping_cost_avg_delivered}
          currency={'USD'}
        />
      ) || '--',
    conditionalCellStyles: [
      {
        when: () => true,
        style: {
          backgroundColor: addAlpha($yellow_warm, '0.8'),
          color: 'black',
        },
        classNames: 'yellow-warm-bg-15 yellow-warm text-center',
      },
    ],
  },
]

const breadcrumbs = [
  {
    name: 'Bookings',
    active: true,
  },
]

const topHeaderColumns = [
  {
    dataKey: 'order_count',
    name: 'Order Count',
    color: addAlpha($light_blue_warm, '0.8'),
  },
  {
    dataKey: 'courier_receivable',
    name: 'Courier Receivable',
    color: addAlpha($light_green_warm, '0.8'),
  },
  {
    dataKey: 'shipping_cost',
    name: 'Shipping Cost',
    color: addAlpha($red_warm, '0.8'),
  },
  {
    dataKey: 'average_shipping',
    name: 'Average Shipping',
    color: addAlpha($yellow_warm, '0.8'),
  },
]

interface CourierBalance {
  courier_id: string
  courier_name: string
  total_orders_delivered: number
  total_orders_returned: number
  total_orders_inprocess: number
  total_amount_delivered: number
  total_amount_inprocess: number
  total_receivable: number
  total_payment_received: number
  balance: number
  shipping_cost_delivered: number
  shipping_cost_returned: number
  shipping_cost_total: number
  shipping_cost_avg_delivered: number
}

interface ApiResponse {
  response: {
    data: CourierBalance[]
    columns?: Array<{
      dataKey: string
      name: string
      selector: string
    }>
    _meta?: {
      total_product_count: number
    }
  }
}

const PaymentStatusWise = () => {
  const [courierBalances, setCourierBalances] = React.useState<
    CourierBalance[]
  >([])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [selectedCourier, setSelectedCourier] =
    React.useState<CourierBalance | null>(null)
  const [tableColumns, setTableColumns] = React.useState<any>([])
  React.useEffect(() => {
    getAllCourierList()
    getAllCourierBalances()
  }, [])

  const getAllCourierList = () => {
    getGeneralCourierList()
  }
  const getAllCourierBalances = (id = null) => {
    setTableLoading(true)
    getCourierBalances(id).subscribe((res: ApiResponse) => {
      setCourierBalances(res.response.data)
      setTableLoading(false)
    })
  }

  const actions = [
    {
      title: 'View Details',
      icon: (
        <Section>
          <PixelIcon color={$DCprimaryColor} icon={faEye} />
        </Section>
      ),
      clickHandler: (row) => {
        setSelectedCourier(row)
        getAllCourierBalances(row.courier_id)
      },
    },
  ]

  const detailsActions = [
    {
      title: 'Download Reports',
      icon: (
        <Section>
          <PixelIcon color={$DCprimaryColor} icon={faFileExport} />
        </Section>
      ),
    },
  ]

  React.useEffect(() => {
    if (selectedCourier) {
      const clms = [...columns].filter((c) => {
        return c.dataKey !== 'shipping_cost_total'
      })
      setTableColumns([
        ...clms,
        {
          dataKey: 'actions',
          name: 'Actions',
          sortable: true,
          selector: (row) => (
            <PixelTableAction row={row} action={detailsActions} />
          ),
        },
      ])
    } else {
      setTableColumns([
        ...columns,
        {
          dataKey: 'actions',
          name: 'Actions',
          sortable: true,
          selector: (row) => <PixelTableAction row={row} action={actions} />,
        },
      ])
    }
  }, [courierBalances])
  return (
    <>
      <PixelPageContainer padding="0 0 0 0">
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="60px"
              fontSize="16px"
              style={{ fontSize: '16px', padding: '8px 0px' }}
            >
              <DcFlexBox
                justifyContent="space-between"
                alignItems="center"
                padding=".5rem 20px"
              >
                <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

                <ProfileSection />
              </DcFlexBox>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <SubHeader>
              {topHeaderColumns.map((col, i) => (
                <HeaderItem key={i}>
                  <PixelIcon
                    style={{
                      color: col.color,
                    }}
                    icon={faCircle}
                  />
                  {col.name}
                </HeaderItem>
              ))}
              {selectedCourier && (
                <>
                  <HeaderItem>
                    {selectedCourier.courier_name}
                    <PixelButton
                      size="sm"
                      variant="link"
                      onClick={() => {
                        setSelectedCourier(null)
                        getAllCourierBalances()
                      }}
                    >
                      Reset Filter
                    </PixelButton>
                  </HeaderItem>
                </>
              )}
            </SubHeader>
            <PixelTable
              columns={tableColumns}
              data={courierBalances}
              isSearchable={false}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

const SubHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  padding: 10px;
  padding-bottom: 20px;
  width: 100%;
  background-color: #fff;
`

const HeaderItem = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: 5px 10px;
  min-height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`

export default PaymentStatusWise
